import { Reducer } from 'redux';

import { AcknowledgeStreamPolicyFulfilledAction } from '../../domains/acknowledgeLiveEventPolicy/actions.types';
import { LiveEventPoliciesLoadFulfilledAction } from '../../domains/liveEventPoliciesLoad/actions.types';

import { StreamPolicyAcknowledged } from './types';

const initialState: StreamPolicyAcknowledged = null;

export type StreamPolicyAcknowledgedAction =
  | AcknowledgeStreamPolicyFulfilledAction
  | LiveEventPoliciesLoadFulfilledAction;

const reducer: Reducer<StreamPolicyAcknowledged> = (state = initialState, action: StreamPolicyAcknowledgedAction) => {
  switch (action.type) {
    case 'LIVE_EVENT_POLICIES.LOAD_FULFILLED':
      return action.payload.entities.streamAcknowledgement;
    case 'ACKNOWLEDGE_STREAM_LIVE_EVENT_POLICY.FULFILLED':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
